/**
 * Customized radii.
 *
 * Reference: https://chakra-ui.com/docs/theming/theme
 */

const radii = {
  none: 0,
  xs: '2px',
  sm: '4px',
  md: '10px',
  lg: '20px',
  xl: '30px',
  xxl: '40px',
  '3xl': '60px',
  '4xl': '70px',
  round: '100px'
};

export default radii;

/* Rounded
 * buttons and badges:
 *  - 70px
 * secondary inputs:
 *  - circles
 *  - 60px (toggles / steppers)
 * cards:
 *  - 40px except xs is 20px
 * popovers:
 *  - 30px except xs is 10px
 * modals:
 *  - 40px
 *
 * Semi-Rounded
 * buttons and badges:
 *  - 10px
 * secondary inputs:
 *  - 6px for checkboxes, etc
 *  - 60px toggles/steppers
 * cards:
 *  - 10px
 * popovers:
 *  - 30px except small is 10px
 * modals:
 *  - 10px
 *
 * Dropdowns
 *  - 8px for hover/selected
 *  - 10px for menu itself
 *  - calendars and date pickers are 30px and 20px
*/
